/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Request to create a new AI Agent session
*/
export class CreateSessionRequest {
  /**
  * Optional session ID. If not provided, a random ID will be generated.
  */
  'sessionId'?: string;
  /**
  * Optional initial state for the session
  */
  'state'?: { [key: string]: any; };
  /**
  * Optional list of events to initialize the session with
  */
  'events'?: Array<{ [key: string]: any; }>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "sessionId",
      "baseName": "session_id",
      "type": "string",
      "format": ""
    },
    {
      "name": "state",
      "baseName": "state",
      "type": "{ [key: string]: any; }",
      "format": ""
    },
    {
      "name": "events",
      "baseName": "events",
      "type": "Array<{ [key: string]: any; }>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CreateSessionRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

